module.exports = __webpack_public_path__ + "img/login-selvaalegre.1fc9dc39.svg";